import axios from '../axios-auth';
import orginal_axios from "axios";

export const menuReportService = {
    getMenuReportList,
    getAllMenuReportList,
    exportMenuReportExcel,
    getMenuReportSummary
}
function getMenuReportSummary(searchParams) {
    let params = {};
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/menu-report-summary/", { params });
}
function getMenuReportList(searchParams, page, size, sortedBy) {
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/menu-report/", { params });
}

function getAllMenuReportList(searchParams) {
    let params = {};
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/menu-report/", { params });

}

function exportMenuReportExcel(searchParams) {
    let params = {
    };
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/menu-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}